import { useCallback } from 'react'
import { useOrgParams } from '~/common/use-org-params'
import { supabaseGetter } from '~/api/supabase-getter'
import { useCreateReferencePolygon } from '~/api/supabase-mutations'
import { useMapRefresh } from '~/map/context/use-map-refresh'

export const useCreateNewReference = ({ name, points, colour }) => {
  const { farmId } = useOrgParams()
  const { createReferencePolygon } = useCreateReferencePolygon()
  const { triggerRefresh } = useMapRefresh()

  const createNewReference = useCallback(async () => {
    const { error } = await createReferencePolygon({
      name,
      colour,
      points,
      parent_organization_id: farmId,
    })

    if (error) throw error

    supabaseGetter.referencePolygons.invalidate()
    triggerRefresh()
  }, [name, points, colour, farmId, createReferencePolygon, triggerRefresh])

  return { createNewReference }
}
